
function ownerLogIn(setOwnerStatus: Function, ownerObject: {}) {
    setOwnerStatus(ownerObject);
    localStorage.setItem('x-access-owner', JSON.stringify(ownerObject));
}

function ownerLogOut(setOwnerStatus: Function) {
    localStorage.removeItem('x-access-owner');
    setOwnerStatus(null);
}

function initOwnerObject(setOwnerStatus: Function) {
    var ownerJsonString = localStorage.getItem('x-access-owner') ?? null;

    ownerJsonString !== null ? setOwnerStatus(JSON.parse(ownerJsonString)) : setOwnerStatus(null);
}

function isOwnerStatusValid(ownerObject: any) {
    if (ownerObject.ownerStatus !== null) {
        const jwtDecode = require('jwt-decode');
        const exp = jwtDecode(ownerObject.ownerStatus.token).exp;

        if (exp < Date.now() / 1000) {
            ownerLogOut(ownerObject.setOwnerStatus);
        } else {
            return true;
        }
    }

    return false
}

export { ownerLogIn, ownerLogOut, initOwnerObject, isOwnerStatusValid }
